<!--
 * @Descripttion: 左侧菜单树
 * @Author: chenjinsheng
 * @Date: 2021-10-26 11:01:20
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-10-26 14:37:40
-->
<template>
    <div class="menu-tree-container">
        <el-scrollbar class="left-box overflow-x-hidden">
            <el-tree
                ref="newsTree"
                :data="sourceTree"
                :props="defaultProps"
                :default-expand-all="false"
                :highlight-current="true"
                :expand-on-click-node="false"
                :current-node-key="currentNodeKey"
                node-key="moduleCode"
                @node-click="handleNodeClick"
                @node-expand="handleNodeExpand"
            >
                <span slot-scope="{ node }" class="custom-tree-node">
                    <span>{{ node.label }}</span>
                </span>
            </el-tree>
        </el-scrollbar>
    </div>
</template>

<script>
import { menuTree } from "./menusConfig";
import { getLocalStorage } from "@/libs/mUtils";
export default {
    name: "SidebarMenu",
    data() {
        return {
            sourceTree: [],
            defaultProps: {
                children: "children",
                label: "label",
            },
            currentNodeKey: "",
        };
    },
    mounted() {
        this.sourceTree = this.filterTree(menuTree);
    },
    methods: {
        // 节点展开回调
        handleNodeExpand() {},
        // 点击节点回调
        handleNodeClick(data) {
            if (data.url) {
                this.$emit("node-click", data.url);
            }
        },
        filterTree(tree, arr = []) {
            if (!tree.length) {
                return [];
            }
            const auth_user = getLocalStorage("user");
            const permissionsList = auth_user.permissionsList || this.permissionsList;
            for (let item of tree) {
                // 循环数组，然后过滤数据
                if (!permissionsList.some((permissionCode) => permissionCode === item.moduleCode)) {
                    continue;
                }
                // 如果满足条件时，用新node代替，然后把chilren清空
                let node = { ...item, children: [] };
                // 然后添加到新数组中
                arr.push(node);
                // 如果有子节点，调用递归函数，并把空数组传给下一个函数
                // 利用引用数据类型的特性，实现浅拷贝
                // 递归函数过滤时会改变这个空数组数据，从而实现层级结构过滤
                if (item.children && item.children.length) {
                    this.filterTree(item.children, node.children);
                }
            }
            return arr;
        },
    },
};
</script>

<style lang="scss" scoped>
.menu-tree-container {
    /deep/ .el-tree-node__content {
        min-height: 44px;
        height: auto !important;
        position: relative;
        border-bottom: 1px solid #f3f3f3;
    }
}
</style>
